import React, { useState } from 'react';
import { Row, Col, Button, Modal, Image } from 'react-bootstrap';
import utils from '../../helpers/utils';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import FadeInImage from '../image/FadeInImage';


const GalleryGrid = ({ mainImage, images }) => {
  const [showModal, setShowModal] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  if (!images || images.length === 0 || !mainImage) return null;

  const allImages = [mainImage, ...images];
  const imgUrls = allImages.map((img) => utils.defaultUrl() + img.filePath);

  const handleImageClick = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <>
      <div className="gallery-grid">
        <Row className="g-2">
          <Col md={6}>
            <div className="position-relative" style={{ cursor: 'pointer' }} onClick={() => setShowModal(true)}>
              <FadeInImage
                src={imgUrls[0]}
                alt={mainImage.fileName}
                className="img-fluid rounded image-1x1"              />
              <Button
                variant="light"
                className="position-absolute bottom-0 start-0 m-2 px-3"
              >
                <i className="fas fa-images me-2" />
                Pokaż wszystkie zdjęcia
              </Button>
            </div>
          </Col>
          <Col md={6}>
            <Row className="g-2">
              {images.slice(0, 4).map((img, idx) => (
                <Col key={img.id} xs={6}>
                  <img
                    src={utils.defaultUrl() + img.filePath}
                    alt={img.fileName}
                    onClick={() => setShowModal(true)}
                    className="img-fluid rounded image-1x1 cursor-pointer"
                  />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </div>

      {/* Modal with grid */}
      <Modal show={showModal} onHide={() => setShowModal(false)} fullscreen>
        <Modal.Header className={'p-4 px-5'} closeButton>
          <Modal.Title>Galeria zdjęć</Modal.Title>
        </Modal.Header>
        <Modal.Body className={'p-4'}>
          <Row className="g-3">
            {allImages.map((img, idx) => (
              <Col key={img.id} xs={12} sm={6} md={4} lg={3}>
                <FadeInImage
                  src={utils.defaultUrl() + img.filePath}
                  alt={img.fileName}
                  rounded
                  className="img-fluid rounded"
                  style={{ cursor: 'pointer', objectFit: 'cover' }}
                  onClick={() => handleImageClick(idx)}
                />

              </Col>
            ))}
          </Row>
        </Modal.Body>
      </Modal>


    </>
  );
};

export default GalleryGrid;
